<template>
    <QDialog
        v-model="opened"
        class="Modal"
    >
        <QCard>
            <QBar class="bg-primary text-white">
                <div class="text-subtitle1 text-weight-medium">
                    {{ $t('dashboards.deleteModal.title') }}
                </div>
                <QSpace />
                <QBtn
                    v-close-popup
                    dense
                    flat
                    color="white"
                    icon="close"
                />
            </QBar>

            <QCardSection>
                <div class="Text">
                    <WText :size="14">
                        {{ $t('dashboards.deleteModal.body', { dashboardName }) }}
                    </WText>
                </div>
            </QCardSection>

            <QCardActions
                align="right"
                class="Buttons"
            >
                <QBtn
                    id="cancel"
                    :label="$t('dashboards.deleteModal.cancel')"
                    noCaps
                    class="ml-1"
                    flat
                    color="primary"
                    @click="close"
                />
                <QBtn
                    id="delete"
                    :label="$t('dashboards.deleteModal.confirm')"
                    noCaps
                    color="primary"
                    outline
                    @click="handleClickConfirm"
                />
            </QCardActions>
        </QCard>
    </QDialog>
</template>

<script>
export default {
    name: 'DeleteModal',
    components: {},
    emits: [
        'onDelete',
    ],
    data() {
        return {
            opened: false,
            dashboardToDelete: undefined,
            dashboardName: undefined,
        }
    },
    methods: {
        open(dashboardToDelete) {
            this.dashboardToDelete = dashboardToDelete
            this.dashboardName = dashboardToDelete.name
            this.opened = true
        },
        close() {
            this.opened = false
        },
        handleClickConfirm() {
            this.$emit('onDelete')
        },
    },
}
</script>

<style scoped lang="scss">
.Modal {
    &:deep(.QDialog) {
        width: 100%;
        max-width: 500px;
    }

    .Buttons {
        padding: 16px 16px 16px 16px;
    }
}
</style>
